var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.317 18.617h-6.044v-.018H16.1v-6.103c0-4.575 3.544-8.296 7.901-8.296 3.724 0 6.855 2.72 7.685 6.366h4.073C34.873 4.59 29.937 0 24 0c-6.562 0-11.9 5.606-11.9 12.496V18.6H11c-1.654 0-3 1.413-3 3.15v23.1C8 46.588 9.346 48 11 48h26c1.654 0 3-1.413 3-3.15v-23.1c0-1.625-1.177-2.966-2.683-3.133ZM36 43.8v-21H12v21h24Zm-13.896-5.25h3.792c.578 0 1.018-.545.923-1.144l-.82-5.156.273-1.145c.37-1.552-.748-3.056-2.272-3.056-1.524 0-2.642 1.504-2.272 3.057L22 32.25l-.82 5.156c-.094.599.346 1.144.924 1.144Z"
  })));
};
export default SvgUnlock;